import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from 'src/app/loader.service';
import { SharedService } from 'src/app/shared/shared.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { Router, ActivatedRoute } from '@angular/router';
import { cityDisplayNameToShiftPrefix } from './utils';
var CreateShiftComponent = /** @class */ (function () {
    function CreateShiftComponent(sharedService, loader, toasterService, router, route) {
        this.sharedService = sharedService;
        this.loader = loader;
        this.toasterService = toasterService;
        this.router = router;
        this.route = route;
        this.shiftFormGroup = new FormGroup({
            city: new FormControl(null, [Validators.required]),
            mode: new FormControl(null, [Validators.required]),
            isDefault: new FormControl(false),
            shiftLabel: new FormControl(null, [Validators.required])
        });
        this.cities = [];
        this.modes = [];
        this.finalShiftName = '';
        this.shiftType = 'regular';
        this.returnTo = '/slabs';
        this.cityIdFromQuery = null;
        this.modeIdFromQuery = null;
        // validate mode once modes load
        this.validateLaunchMode = false;
    }
    Object.defineProperty(CreateShiftComponent.prototype, "cityPrefix", {
        get: function () {
            var city = this.shiftFormGroup.get('city').value;
            if (!city)
                return '';
            return city.name ? cityDisplayNameToShiftPrefix(city.name) : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateShiftComponent.prototype, "modePrefix", {
        get: function () {
            var mode = this.shiftFormGroup.get('mode').value;
            if (!mode)
                return '';
            return mode.name ? mode.name.toUpperCase() : '';
        },
        enumerable: true,
        configurable: true
    });
    CreateShiftComponent.prototype.ngOnInit = function () {
        var _this = this;
        var params = this.route.snapshot.queryParams;
        if (params['returnTo']) {
            this.returnTo = params['returnTo'];
        }
        this.cityIdFromQuery = (params['city'] || '').trim() || null;
        this.modeIdFromQuery = (params['mode'] || '').trim() || null;
        this.validateLaunchMode = !!this.cityIdFromQuery;
        this.fetchCities();
        this.shiftFormGroup.get('city').valueChanges.subscribe(function () {
            _this.shiftFormGroup.get('mode').setValue(null);
            _this.updateFinalName();
            if (_this.shiftFormGroup.get('city').value) {
                _this.fetchModes(_this.shiftFormGroup.get('city').value.id);
            }
        });
        this.shiftFormGroup.get('mode').valueChanges.subscribe(function () {
            _this.updateFinalName();
        });
        this.shiftFormGroup.get('shiftLabel').valueChanges.subscribe(function (val) {
            if (val && val !== val.toUpperCase()) {
                _this.shiftFormGroup.get('shiftLabel').setValue(val.toUpperCase(), { emitEvent: false });
            }
            _this.updateFinalName();
        });
    };
    CreateShiftComponent.prototype.setShiftType = function (type) {
        this.shiftType = type;
        var shiftLabelControl = this.shiftFormGroup.get('shiftLabel');
        if (type === 'default') {
            this.shiftFormGroup.get('isDefault').setValue(true);
            shiftLabelControl.clearValidators();
            shiftLabelControl.setValue(null);
            shiftLabelControl.disable();
        }
        else {
            this.shiftFormGroup.get('isDefault').setValue(false);
            shiftLabelControl.setValidators([Validators.required]);
            shiftLabelControl.enable();
        }
        shiftLabelControl.updateValueAndValidity();
        this.updateFinalName();
    };
    CreateShiftComponent.prototype.fetchCities = function () {
        var _this = this;
        this.loader.openLoading();
        this.sharedService.fetchCities()
            .toPromise()
            .then(function (res) {
            _this.cities = res.data.cities
                .filter(function (city) { return city.active; })
                .map(function (city) { return ({
                id: city._id,
                name: city.displayName,
            }); });
            // Pre-select city if cityId is provided in query params
            if (_this.cityIdFromQuery && _this.cities.length > 0) {
                var city = _this.cities.find(function (c) { return c.id === _this.cityIdFromQuery; });
                if (city) {
                    _this.shiftFormGroup.get('city').setValue(city);
                }
            }
        })
            .catch(function (error) {
            _this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: 'Error fetching cities' }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateShiftComponent.prototype.fetchModes = function (cityId) {
        var _this = this;
        if (!cityId)
            return;
        this.loader.openLoading();
        this.sharedService.fetchModes(cityId)
            .toPromise()
            .then(function (res) {
            _this.modes = res.data.modes || [];
            if (_this.validateLaunchMode) {
                _this.validateLaunchMode = false;
                if (!_this.modeIdFromQuery) {
                    _this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: 'Mode is required in launch URL.',
                    }));
                }
                else {
                    var mode = _this.modes.find(function (m) { return String(m.id) === String(_this.modeIdFromQuery); });
                    if (mode) {
                        _this.shiftFormGroup.get('mode').setValue(mode);
                    }
                    else {
                        _this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: 'Invalid mode in launch URL for the selected city.',
                        }));
                    }
                }
                _this.modeIdFromQuery = null;
            }
        })
            .catch(function (error) {
            console.error("Error fetching modes:", error);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Error fetching modes'
            }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateShiftComponent.prototype.updateFinalName = function () {
        var city = this.shiftFormGroup.get('city').value;
        var mode = this.shiftFormGroup.get('mode').value;
        var isDefault = this.shiftFormGroup.get('isDefault').value;
        var shiftLabel = this.shiftFormGroup.get('shiftLabel').value;
        if (city && mode) {
            var cityName = city.name ? cityDisplayNameToShiftPrefix(city.name) : '';
            var modeName = mode.name ? mode.name.toUpperCase() : '';
            if (isDefault) {
                this.finalShiftName = cityName + "_" + modeName + "_DEFAULT";
            }
            else if (shiftLabel) {
                var label = shiftLabel.toUpperCase().trim();
                this.finalShiftName = cityName + "_" + modeName + "_" + label;
            }
            else {
                this.finalShiftName = '';
            }
        }
        else {
            this.finalShiftName = '';
        }
    };
    CreateShiftComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.shiftFormGroup.invalid) {
            this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: 'Please fill all required fields' }));
            return;
        }
        var city = this.shiftFormGroup.get('city').value;
        var mode = this.shiftFormGroup.get('mode').value;
        var isDefault = this.shiftFormGroup.get('isDefault').value;
        var shiftLabel = this.shiftFormGroup.get('shiftLabel').value;
        if (!city || !mode || (!isDefault && !shiftLabel)) {
            this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: 'Please fill all required fields' }));
            return;
        }
        this.loader.openLoading();
        this.sharedService.createShift({
            cities: [city.id],
            mode: mode.id,
            shiftName: this.finalShiftName,
            isDefault: isDefault
        })
            .toPromise()
            .then(function (res) {
            _this.toasterService.showToaster(new Toaster({ type: ToasterType.SUCCESS, message: 'Shift created successfully' }));
            _this.router.navigate([_this.returnTo]);
        })
            .catch(function (error) {
            var errorMessage = 'Failed to create shift';
            if (error && error.error) {
                var body = error.error;
                if (body.data && body.data.error) {
                    if (body.data.error.message) {
                        errorMessage = body.data.error.message;
                    }
                    else if (typeof body.data.error === 'string') {
                        errorMessage = body.data.error;
                    }
                }
                else if (body.message) {
                    errorMessage = body.message;
                }
            }
            else if (error && error.message) {
                errorMessage = error.message;
            }
            _this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: errorMessage }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateShiftComponent.prototype.onCancel = function () {
        this.router.navigate([this.returnTo]);
    };
    return CreateShiftComponent;
}());
export { CreateShiftComponent };
